import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  CdDeliveryPayment,
  IssuePayment,
} from '../../../../shared/api/hscan/hospital';
import { useMailingOrder } from '../../../../shared/hooks/hospitalHook';
import { getEpostTrackingUrl } from '../../../../shared/utils';
import {
  BlueStatusMessage,
  GreyStatusMessage,
  GreenStatusMessage,
} from '../../common/components/styledComponents';

interface TrackingNumberMessageProps {
  payment: IssuePayment | CdDeliveryPayment;
}
export const TrackingNumberMessage = ({
  payment,
}: TrackingNumberMessageProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.mypage.payments.table.mailStatus',
  });

  const { refetch: fetchMailingOrder } = useMailingOrder(payment.id, {
    enabled: false,
  });

  const onClickTrackingNumber = async () => {
    const { data } = await fetchMailingOrder();
    if (!data) {
      return;
    }
    if (!data.trackingNumber) {
      return;
    }
    const trackingUrl = getEpostTrackingUrl(data.trackingNumber);
    window.open(trackingUrl, undefined, 'noopener,noreferrer');
  };

  return payment.mailStatus === 'ORDER_ONLINE_DONE' ? (
    <GreyStatusMessage>{`${t('online')}`}</GreyStatusMessage>
  ) : payment.mailStatus === 'ORDER_PENDING' ||
    payment.mailStatus === 'ORDER_MAIL_AVAILABLE' ? (
    <GreenStatusMessage>{t('waitForMail')}</GreenStatusMessage>
  ) : payment.mailStatus === 'ORDER_MAILED' ? (
    <BlueStatusMessage onClick={onClickTrackingNumber}>
      {t('mailed')}
    </BlueStatusMessage>
  ) : (
    <GreyStatusMessage>{t('mailCanceled')}</GreyStatusMessage>
  );
};
